import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import LocaleContext from '../../LocaleContext';
import formatDate from '../../helpers/formatDate';
import formatTime from '../../helpers/formatTime';

const Format = ({ children, type}) => {
    const {locale} = useContext(LocaleContext);
    if(type === 'date'){
        const date = formatDate(children, locale);
        return <>{date}</>;
    }
    if(type === 'time'){
        const time = formatTime(children, locale);
        return <>{time}</>
    }
    return <>{children}</>
};

Format.propTypes = {
    children: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['date', 'time']),
};

export default Format;
